import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJava,
  DiAndroid,
} from "react-icons/di";
import {
  SiFirebase,
  SiKotlin,
  SiSpringboot,
  SiPostgresql,
  SiFlutter,
  SiDart,
} from "react-icons/si";

const techSkills = [
  { icon: <SiFlutter />, name: "Flutter", link: "https://flutter.dev/" },
  { icon: <SiDart />, name: "Dart", link: "https://dart.dev/" },
  { icon: <SiKotlin />, name: "Kotlin", link: "https://kotlinlang.org/" },
  { icon: <DiAndroid />, name: "Android", link: "https://developer.android.com/" },
  { icon: <SiSpringboot />, name: "Spring Boot", link: "https://spring.io/projects/spring-boot" },
  { icon: <DiJava />, name: "Java", link: "https://www.java.com/" },
  { icon: <SiPostgresql />, name: "PostgreSQL", link: "https://www.postgresql.org/" },
  { icon: <SiFirebase />, name: "Firebase", link: "https://firebase.google.com/" }
];

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {techSkills.map((skill, index) => (
        <Col xs={4} sm={3} md={2} key={index} className="d-flex justify-content-center mb-4">
          <a
            href={skill.link}
            target="_blank"
            rel="noopener noreferrer"
            className="tech-icons"
            style={{
              color: "inherit",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {skill.icon}
            <span className="tech-icons-text">{skill.name}</span>
          </a>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
